// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3rb6j","messages":"Chat_messages__3WF_6","dateDivider":"Chat_dateDivider__NaaxD"};